/**
 * Utilidades compartidas para componentes de selección
 */

import { SelectOption } from './types';

/**
 * Convierte objetos {id: texto} en array [{value, label}]
 */
export const mapOptions = (obj: Record<string, string> | undefined): SelectOption[] => {
  if (!obj) return [];
  return Object.entries(obj)
    .map(([value, label]) => ({ 
      value, 
      // Capitaliza la primera letra de cada palabra en la etiqueta, corregir para funcionen los acentos y las ñ

      label: label.toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase())
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

/**
 * Extrae mensaje de error genérico
 */
export const getErrorMessage = (err: unknown, defaultMessage: string): string => {
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object') {
    const msg = (err as any).message;
    return typeof msg === 'string' ? msg : JSON.stringify(err);
  }
  return defaultMessage;
};

/**
 * Valida si un array es válido y no está vacío
 */
export const isValidArray = (arr: any): arr is any[] => {
  return Array.isArray(arr) && arr.length > 0;
};
